import { render, staticRenderFns } from "./SendViaInMailButton.vue?vue&type=template&id=9af86d1a"
import script from "./SendViaInMailButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SendViaInMailButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports